<div class="message-container">
  <mat-icon *ngIf="icon === 'warning'" color="warn">{{icon}}</mat-icon>
  <mat-icon *ngIf="icon !== 'warning'" color="accent">{{icon}}</mat-icon>
  <div class="text-container"><p>{{message}}</p></div>
</div>
